import backgroundLayers from './layers/backgroundLayers';
import vectorLayers from './layers/vectorLayers';

export default {
	key: '5f02bf8f-e034-45f8-81b0-5266fd54af8a',
	data: {
		state: {
			insar: {
				types: {
					activeKey: 'los',
				},
				orbitalTrajectories: {
					activeKeys: ['asc'],
				},
				visualizations: {
					activeKey: 'displacement',
				},
			},
			components: {
				introOverlay: {
					open: true,
				},
				controlPanel: {
					minimised: false,
					chartExpanded: false,
					activeDivision: 'zones',
				},
				InterferometryChart: {
					rangeType: 'dynamic',
				},
			},
			maps: {
				activeMapKey: 'zones',
				maps: {
					interferometry: {
						key: 'interferometry',
						data: {
							layers: [
								vectorLayers.interferometryZones,
								vectorLayers.interferometryPoints,
							],
						},
					},
					'interferometry-small': {
						key: 'interferometry-small',
						data: {
							layers: [
								vectorLayers.interferometryZonesSmall,
								vectorLayers.interferometryPointsSmall,
							],
							view: {
								boxRange: 3000,
							},
						},
					},
					zones: {
						key: 'zones',
						data: {
							layers: [vectorLayers.zones],
						},
					},
					'zones-small': {
						key: 'zones-small',
						data: {
							view: {
								boxRange: 3000,
							},
							layers: [vectorLayers.zonesSmall],
						},
					},
				},
				sets: {
					interferometry: {
						key: 'interferometry',
						activeMapKey: 'interferometry',
						maps: ['interferometry', 'interferometry-small'],
						sync: {
							center: true,
						},
						data: {
							backgroundLayer: backgroundLayers.imagery,
							view: {
								boxRange: 3000,
								center: {
									lat: -13.834,
									lon: -171.735,
								},
							},
							viewLimits: {
								boxRangeRange: [400, 5000000],
							},
						},
					},
					zones: {
						key: 'zones',
						activeMapKey: 'zones',
						maps: ['zones', 'zones-small'],
						sync: {
							center: true,
						},
						data: {
							backgroundLayer: backgroundLayers.imagery,
							view: {
								boxRange: 3000,
								center: {
									lat: -13.834,
									lon: -171.735,
								},
							},
							viewLimits: {
								boxRangeRange: [400, 5000000],
							},
						},
					},
				},
			},
			selections: {
				activeKey: 'zones',
				data: [
					{
						key: 'interferometry',
						data: {
							style: {
								outlineOpacity: 1,
								outlineWidth: 2,
								outlineColor: '#00fffe',
							},
						},
					},
					{
						key: 'zones',
						data: {
							style: {
								outlineOpacity: 1,
								outlineWidth: 2,
								outlineColor: '#00fffe',
							},
						},
					},
				],
			},
		},
	},
};
